module.exports = __webpack_public_path__ + "static/img/WechatIMG124.00ee5a4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/explain/WechatIMG124.jpeg
// module id = 910
// module chunks = 0